import { BundlePlatformFilesInput } from "../../generated/graphql";
import { ModelBundleFormData } from "./modals/BundleFormModalContext";

export const bundleManifestKeys = [
  "iosBundleUrl",
  "iosManifestUrl",
  "androidBundleUrl",
  "androidManifestUrl",
  "webGlBundleUrl",
  "webGlManifestUrl",
  "vrBundleUrl",
  "vrManifestUrl",
  "interactiveWhiteboardAndroidBundleUrl",
  "interactiveWhiteboardAndroidManifestUrl",
  "interactiveWhiteboardWindowsBundleUrl",
  "interactiveWhiteboardWindowsManifestUrl",
  "roomBundleUrl",
  "roomManifestUrl",
] as const;

export const hasFilledField = (
  modelData: ModelBundleFormData,
  keys: readonly string[],
) => keys.some((key) => !!modelData[key]);

export const validateModelBundle = (modelData: ModelBundleFormData) => {
  const hasName = !!modelData.name?.trim();
  const hasContentType = !!modelData.contentType;
  const validPlatforms: BundlePlatformFilesInput[] = (
    modelData.platforms ?? []
  ).filter((p): p is BundlePlatformFilesInput => {
    return !!p?.platform && !!p?.bundle && !!p?.manifest;
  });
  const hasBundleOrManifest = hasFilledField(modelData, bundleManifestKeys);
  const hasPlatforms = validPlatforms.length > 0;

  return hasName && hasContentType && (hasPlatforms || hasBundleOrManifest);
};
